/** @jsx jsx */
import { jsx } from '@emotion/core'
import { observer } from 'mobx-react'
import React, { Fragment, useState } from 'react'
import { message } from 'antd'
import { List, Modal } from 'antd-mobile'
import { nth } from 'lodash'
import { isMobile } from 'react-device-detect'
import { PUBLISH_PICK_TYPE } from '@constants/index'
// css
import { ModalBg, ModalContents, Point, TxtLimit } from '@styles/base.style'
import { Button, ButtonWrap, CloseBtn, ModalFooterWrap, PopupBtnStyle } from '@styles/button.style'
// icon
import { GmoneyIco } from '@shared/Icon/MoneyIcon'
import DummyImg from '@assets/images/itemshop/skin_dummy.png'
import useRootStore from '@store/useRootStore'
import { useOnMount } from '@utils/reactExt'
import { formatNumber, getPickPublishMoney } from '@utils/utils'
import { Schema$Pick } from '@protocol/pick'
import { PickWrap } from '@views/Pick/PickList/index.style'
import { ModalBodyWarp } from './index.style'
import dayjs from 'dayjs'
// import { Schema$Pick } from '@v2/protocol/pick'

const picksterIco = <img key="dummy" src={DummyImg} alt="프로필"/>
const Gmoney = <GmoneyIco/>

interface PickSelectorProps {
  visible: boolean
  setVisible: (arg: boolean) => void
  setPick: (arg: Schema$Pick) => void
}

const PickSelector: React.FC<PickSelectorProps> = (props: PickSelectorProps) => {
  const { visible, setVisible, setPick } = props
  const { pickStore } = useRootStore()
  const { publishPickList } = pickStore
  const [selector, setSelector] = useState(null)
  const days = ['일', '월', '화', '수', '목', '금', '토']
  const pickItems = []

  const fetchPublishItem = async () => {
    await pickStore.fetchPublishPick({})
  }

  useOnMount(fetchPublishItem)

  // TODO 중복되는 코드가 존재하므로 찾아서 개선할 것. - MessageContent.tsx#getDateFormat, MessageListItemFooter.tsx#getDateFormat
  const getDateFormat = (date: string): string => {
    const d = dayjs(date)
    const f = [d.format('MM/DD'), '(', nth(days, d.day()), ') ', d.format('HH:mm')]
    return f.join('')
  }

  const onClickCloseButtonHandler = () => {
    setVisible(false)
    if (selector) {
      setSelector(null)
    }
  }

  if (publishPickList) {
    const { items } = publishPickList
    for (const el of items) {
      let className = ''
      if (selector && Object.prototype.hasOwnProperty.call(selector, 'pickId')) {
        const { pickId } = selector
        if (pickId === el.pickId) {
          className = 'list-item-selector'
        }
      }
      const onClickPickItem = () => {
        if (selector && selector === el) {
          setSelector(null)
        } else {
          setSelector(el)
        }
      }

      const priceMoney = getPickPublishMoney(el.publishMoneyType, el.priceMoney)
      const item = (
        <List.Item key={el.pickId} className={className} onClick={onClickPickItem}>
          <PickWrap>
            <span className="pick-date">{getDateFormat(el.dateBettingEnd)}</span>
            <h3 className="pick-list-tit">{el.title}</h3>

            <div className="pick-list">
              <span className="pick-list--pickster-info">
                <span className="pick-list--pickster-info--pickster-img">{picksterIco}</span>
                <span className="pick-list--pickster-info--pickster">
                  <span className="pick-list--pickster-info--pickster--name">{el.picksterName}</span>
                  <span className="pick-list--pickster-info--pickster--hit-rate">
                    적중률
                  </span>
                  <span className="pick-list--pickster-info--pickster--percent">10{el.userHitRatioTotal}%</span>
                </span>
              </span>

              <span className="pick-list--pick-info">
                <span className="pick-list--pick-info--sub">
                  <span className="pick-list--pick-info--sub--txt">폴드</span>
                  <span className="pick-list--pick-info--sub--num">{el.foldCount}</span>
                </span>
                <span className="pick-list--pick-info--sub">
                  <span className="pick-list--pick-info--sub--txt">배당</span>
                  <Point>{el.dividendRate}</Point>
                </span>
                <span className="pick-list--pick-info--sub price">
                  <span className="pick-list--pick-info--sub--txt">판매가</span>
                  <span className="pick-list--pick-info--sub--money-wrap">
                    <span className="pick-list--pick-info--sub--money-wrap--money" css={TxtLimit}>{formatNumber(priceMoney)}</span>
                    <span className="pick-list--pick-info--sub--money-wrap--icon">
                      {el.publishMoneyType === PUBLISH_PICK_TYPE.HEART ? Gmoney : '개'}
                    </span>
                  </span>
                </span>
              </span>
            </div>
          </PickWrap>
        </List.Item>
      )
      pickItems.push(item)
    }
  }

  const onClickPickShareButton = () => {
    if (selector) {
      setPick(selector)
      onClickCloseButtonHandler()
    } else {
      message.info('공유 할 픽이 없습니다.')
    }
  }

  return (
    <Fragment>
      <Modal
        popup
        maskClosable={false}
        visible={visible}
        animated={isMobile}
        animationType="slide-up"
        onClose={onClickCloseButtonHandler}
        title={
          <Fragment>
            <h1 className="title">픽 공유</h1>
            <Button onClick={onClickCloseButtonHandler} className="close-btn" css={CloseBtn}>
              <span className="close-txt">닫기</span>
            </Button>
          </Fragment>
        }
        className="full-modal"
      >
        <ModalContents className="bottom-space">
          <ModalBodyWarp>
            <List>{pickItems}</List>
          </ModalBodyWarp>
        </ModalContents>
        <ModalFooterWrap>
          <ButtonWrap>
            <Button css={PopupBtnStyle} onClick={onClickCloseButtonHandler} className="two-button cancel bottom-btn modal">
              취소
            </Button>
            <Button primary css={PopupBtnStyle} onClick={onClickPickShareButton} className="two-button bottom-btn modal">
              공유
            </Button>
          </ButtonWrap>
        </ModalFooterWrap>

        <ModalBg onClick={onClickCloseButtonHandler}/>
      </Modal>
    </Fragment>
  )
}

export default observer(PickSelector)
